var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useState, } from "react";
import { getAutomation, getLastAction, setAutomation, } from "../api/CarboniteApi";
import { useSse } from "./SseContext";
var AutomationContext = createContext(undefined);
var AutomationProvider = function (_a) {
    var children = _a.children;
    var _b = useSse(), automationState = _b.automationState, lastActionState = _b.lastActionState;
    var _c = useState("disable"), currentAutomationState = _c[0], setCurrentAutomationState = _c[1];
    var _d = useState("Slate"), currentNTLState = _d[0], setCurrentNTLState = _d[1];
    var _e = useState("Slate"), currentRSNState = _e[0], setCurrentRSNState = _e[1];
    var _f = useState(""), lastAction = _f[0], setLastAction = _f[1];
    useEffect(function () {
        getAutomation().then(function (response) {
            response
                ? setCurrentAutomationState("enable")
                : setCurrentAutomationState("disable");
        });
        getLastAction().then(function (initialData) {
            setCurrentRSNState(initialData["RSN"]);
            setCurrentNTLState(initialData["NTL"]);
            setLastAction(initialData["lastAction"]);
        });
        console.log("initial", automationState);
        // getAutomation().then(() => {
        //   setCurrentAutomationState(automationState);
        //   console.log(automationState);
        // });
    }, []);
    //updates from SSE
    useEffect(function () {
        currentAutomationState !== automationState &&
            setCurrentAutomationState(automationState);
        console.log(automationState);
    }, [automationState]);
    useEffect(function () {
        setCurrentRSNState(lastActionState["RSN"]);
        setCurrentNTLState(lastActionState["NTL"]);
        setLastAction(lastActionState["lastAction"]);
        console.log(lastActionState);
    }, [lastActionState]);
    //update automationState on toggle selection
    var updateAutomation = function (selectedValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                setAutomation(selectedValue).then();
            }
            catch (error) {
                // Handle error
                console.error("Error updating automation:", error);
            }
            return [2 /*return*/];
        });
    }); };
    return (_jsx(AutomationContext.Provider, __assign({ value: {
            currentAutomationState: currentAutomationState,
            currentNTLState: currentNTLState,
            currentRSNState: currentRSNState,
            lastAction: lastAction,
            updateAutomation: updateAutomation,
        } }, { children: children })));
};
var useAutomation = function () {
    var contextValue = useContext(AutomationContext);
    if (contextValue === undefined) {
        throw new Error("useAutomation must be used within an AutomationProvider");
    }
    return contextValue;
};
export { AutomationContext, AutomationProvider, useAutomation };
